// userID is not getting updated correctly thats why it is opening create admin page even though we are opening modify admin.

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
// import { useRef } from "react";
import { Formik, Field } from "formik";
import {
  Button,
  Form,
  FormGroup,
  Container,
  Col,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
} from "reactstrap";
import * as Yup from "yup";
import MultiSelect from "@kenshooui/react-multi-select";
import ErrorMessage from "../Utils/ErrorMessage";
// import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Loading } from "../../loader/Loading";
import DocumentTitle from "react-document-title";
import { countries } from "../Constants/static";
import {
  getRoles,
  // staticPoolRoles,
  adminCreateUser,
  getAdminUserDetails,
  updateAdminUser,
} from "../../actions/admin";
import { isEmpty } from "lodash";
import SubmissionPopup from "../User/Create/submissionModal";
import Mapping from "../Utils/Mapping";
import errors from "../Constants/errors.json";
import ErrorFocus from "../Error/ErrorFocus";
import _ from "lodash";
// import usePrevious from "./customHooks/usePrevious";
// import useGetId from "./customHooks/useGetId";

const AdminForm = (props) => {
  const { userDetails, roles, usercreated, usermodified, staticPoolRoles } =
    useSelector((state) => state?.admin);

  const isLoading = useSelector((state) => state?.fetch?.isLoading);
  const error = useSelector((state) => state?.error?.error_obj);
  // const pool = useSelector((state) => state?.pool?.userPool);
  const superAdmin = useSelector((state) => state?.account?.superAdmin);

  const dispatch = useDispatch();

  const [currState, setCurrState] = useState({
    modal: false,
    message: "",
    color: "",
    user: {},
    initialAccessroles: [],
    accessroles: [],
    existingStatus: "",
    cognito_super_admin: false,
    userpoolRoles: [],
    rolesList: [],
    disabled: false,
    aTouch: false,
    uTouch: false,
    rTouch: false,
    adminTouch: false,
    userID: undefined,
  });

  // const userId = useGetId(currState);
  let temp = useParams()["*"];
  let userId = temp !== "createadmin" ? temp : undefined;

  useEffect(() => {
    dispatch({ type: "SET_ERROR", data: { error_obj: undefined } }); //error_obj => undefined
    dispatch({
      type: "SET_ADMIN_CREATE_USER",
      data: { usercreated: undefined },
    }); //usercreated => undefined
    dispatch({
      type: "SET_ADMIN_MODIFY_USER",
      data: { usermodified: undefined },
    }); //usermodified => undefined
    dispatch(getRoles()); //setting up => {roles: roles, staticPoolRoles: statictRoles}
    if (userId) {
      // setCurrState({
      //   ...currState,
      //   userID: userId,
      //   disabled: true,
      // });
      setCurrState((prevState) => {
        return {
          ...prevState,
          userID: userId,
          disabled: true,
        };
      });
      dispatch(getAdminUserDetails(userId)); // setting up => { userDetails: { ...res.data, ...Attributes } }
    } else {
      dispatch({ type: "SET_ERROR", data: { error_obj: undefined } });
      dispatch({ type: "SET_ROLES_LIST", data: { roles: undefined } });
      dispatch({
        type: "SET_ADMIN_CREATE_USER",
        data: { usercreated: undefined },
      });
      dispatch({
        type: "SET_ADMIN_USER_DETAILS",
        data: { userDetails: undefined },
      });
      setCurrState({
        modal: false,
        message: "",
        color: "",
        user: {},
        initialAccessroles: [],
        accessroles: [],
        existingStatus: "",
        cognito_super_admin: false,
        userpoolRoles: [],
        rolesList: [],
        disabled: false,
        aTouch: false,
        uTouch: false,
        rTouch: false,
        adminTouch: false,
        userID: undefined,
      });
    }

    return () => {
      setCurrState((prevState) => {
        return {
          ...prevState,
          modal: false,
          message: "",
          color: "",
        };
      });
      dispatch({ type: "SET_ERROR", data: { error_obj: undefined } });
      dispatch({ type: "SET_ROLES_LIST", data: { roles: undefined } });
      dispatch({
        type: "SET_ADMIN_CREATE_USER",
        data: { usercreated: undefined },
      });
      dispatch({
        type: "SET_ADMIN_USER_DETAILS",
        data: { userDetails: undefined },
      });
    };
  }, [userId, dispatch]);
  //why failing for currState in dependency?

  useEffect(() => {
    if (userDetails === undefined) {
      dispatch({ type: "SET_ERROR", data: { error_obj: undefined } });
      dispatch({ type: "SET_ROLES_LIST", data: { roles: undefined } });
      dispatch({
        type: "SET_ADMIN_CREATE_USER",
        data: { usercreated: undefined },
      });
      dispatch({
        type: "SET_ADMIN_USER_DETAILS",
        data: { userDetails: undefined },
      });
      setCurrState({
        modal: false,
        message: "",
        color: "",
        user: {},
        initialAccessroles: [],
        accessroles: [],
        existingStatus: "",
        cognito_super_admin: false,
        userpoolRoles: [],
        rolesList: [],
        disabled: false,
        aTouch: false,
        uTouch: false,
        rTouch: false,
        adminTouch: false,
        userID: undefined,
      });
    }
  }, [userDetails, dispatch]);
  useEffect(() => {
    let newState = {};
    let formattedRoles = [];
    roles &&
      roles.roles &&
      Object.keys(roles.roles).forEach((key) => {
        formattedRoles.push(...roles.roles[key]);
      });
    if (error) {
      let errorMessage = (error.code &&
        error.code.message &&
        error.code.message.message) ||
        error.message || <Mapping dictionary={errors} word={error.errorPath} />;
      newState = { modal: true, message: errorMessage, color: "danger" };
      setCurrState({
        ...currState,
        ...newState,
      });
    } else if (userDetails && formattedRoles.length > 0) {
      let useraccessRoles = userDetails["custom:accessrole"];
      let userAccessRolesArray =
        (useraccessRoles && useraccessRoles.split(",")) || [];
      let finalUserAccessRolesObjectArray = userAccessRolesArray
        .map((userrole) => {
          let role = formattedRoles.find((role) => role === userrole);
          return role ? role : null;
        })
        .filter((r) => r);
      finalUserAccessRolesObjectArray = finalUserAccessRolesObjectArray.map(
        (role) => {
          let staticPoolRole = staticPoolRoles.find(
            (poolrole) => role.split("_")[0] === poolrole.id
          );

          let disabled = staticPoolRole && staticPoolRole.disabled;
          // return { id: role.role_name, label: role.role_desc, disabled };
          return { id: role, label: role, disabled };
        }
      );
      let nAccessRoles =
        currState.aTouch || currState.uTouch
          ? currState.accessroles
          : finalUserAccessRolesObjectArray;
      let userPoolRoles = userDetails["custom:userpoolRole"];
      let userPoolRolesArray =
        (userPoolRoles && userPoolRoles.split(",")) || [];
      let finalUserPoolRolesObjectArray = userPoolRolesArray
        .map((userrole) => {
          return staticPoolRoles.find((role) => role.id === userrole);
        })
        .filter((r) => r);
      let accessrolesList = []; // access roleslist to be displayed with disabled access roles based on the user privileges
      let pools =
        finalUserPoolRolesObjectArray.length > 0 &&
        finalUserPoolRolesObjectArray.map((pool) => pool.id);
      pools.length > 0 &&
        pools.forEach((pool) => {
          roles.roles[pool].forEach((poolaccessroles) => {
            let disabled = staticPoolRoles.find(
              (poolrole) => poolrole.id === pool
            ).disabled;
            accessrolesList.push({
              id: poolaccessroles,
              label: poolaccessroles,
              disabled,
            });
          });
        });
      let nUserPoolRoles = currState.uTouch
        ? currState.userpoolRoles
        : finalUserPoolRolesObjectArray;
      let nSuperAdmin = currState.adminTouch
        ? currState.cognito_super_admin
        : userDetails["custom:accessrole"] &&
          userDetails["custom:accessrole"]
            .split(",")
            .includes("COGNITO_SUPER_ADMIN")
        ? true
        : false;
      newState = {
        accessroles: nAccessRoles,
        userpoolRoles: nUserPoolRoles,
        existingStatus: !userDetails["Enabled"],
        rolesList: currState.rTouch ? currState.rolesList : accessrolesList,
        cognito_super_admin: nSuperAdmin,
        userID: userId !== undefined ? userId : "",
      };
      setCurrState({
        ...currState,
        ...newState,
      });
    }
  }, [
    userDetails,
    error,
    roles,
  ]);
  // userDetails, error, roles

  useEffect(() => {
    if (usercreated) {
      setCurrState((prevState) => {
        return {
          ...prevState,
          modal: true,
          message: usercreated,
          color: "success",
          userID: userId !== undefined ? userId : "",
        };
      });
    }
    if (usermodified) {
      setCurrState((prevState) => {
        return {
          ...prevState,
          modal: true,
          message: "User Modified Successfully",
          color: "success",
          userID: userId !== undefined ? userId : "",
        };
      });
    }
  }, [usercreated, usermodified]);

  //const prev = usePrevious(userDetails);

  // useEffect(() => {
  //   console.log("CurrState UseEffect Prev ===>",currState,prev);
  //   let superadmin =
  //     userDetails &&
  //     userDetails["custom:accessrole"] &&
  //     userDetails["custom:accessrole"]
  //       .split(",")
  //       .includes("COGNITO_SUPER_ADMIN");
  //   if (prev?.userDetails !== userDetails && superadmin) {
  //     setCurrState({ ...currState, accessroles: [], userpoolRoles: [] });
  //   }
  // }, [userDetails]);

  function toggle() {
    setCurrState((prevState) => {
      return {
        ...prevState,
        modal: !currState.modal,
        message: "",
        color: "",
      };
    });
    currState?.userID && !error && getAdminUserDetailsFn(currState.userID);
  }

  const optionListCountries = (list) => {
    return list.map((opt, index) => {
      return (
        <option value={opt} key={index}>
          {opt}
        </option>
      );
    });
  };

  // function getRolesFn() {
  //   dispatch(getRoles());
  // }

  function adminCreateUserFn(attributes, email) {
    dispatch(adminCreateUser(attributes, email));
  }

  // function clearRolesFn() {
  //   dispatch({ type: "SET_ROLES_LIST", data: { roles: undefined } });
  // }

  function clearErrorFn() {
    dispatch({ type: "SET_ERROR", data: { error_obj: undefined } });
  }

  function clearUserCreatedFn() {
    dispatch({
      type: "SET_ADMIN_CREATE_USER",
      data: { usercreated: undefined },
    });
  }

  function getAdminUserDetailsFn(username) {
    dispatch(getAdminUserDetails(username));
  }

  function clearModifyUserFn() {
    dispatch({
      type: "SET_ADMIN_MODIFY_USER",
      data: { usermodified: undefined },
    });
  }

  // function clearUserDetailsFn() {
  //   dispatch({
  //     type: "SET_ADMIN_USER_DETAILS",
  //     data: { userDetails: undefined },
  //   });
  // }

  function updateAdminUserFn(username, Attributes) {
    dispatch(updateAdminUser(username, Attributes));
  }

  const generateAccessRoles = (poolroles, selectedaccessroles) => {
    let accessroles = [];
    let pools = poolroles.length > 0 && poolroles.map((pool) => pool.id);

    pools.length > 0 &&
      pools.forEach((pool) => {
        roles.roles[pool].forEach((poolaccessroles) => {
          let disabled = staticPoolRoles.find(
            (poolrole) => poolrole.id === pool
          ).disabled;
          accessroles.push({
            id: poolaccessroles,
            label: poolaccessroles,
            disabled,
            // id: poolaccessroles.role_name,
            // label: `${poolaccessroles.role_desc}`,
            // disabled
          });
        });
      });

    setCurrState({
      ...currState,
      userpoolRoles: poolroles,
      uTouch: true,
      accessroles: selectedaccessroles,
      rolesList: accessroles,
      rTouch: true,
    });
  };

  const filterSelectedAccessRoles = (poolroles) => {
    let selectedaccessroles = [];
    let selectedPools =
      poolroles && poolroles.length > 0 && poolroles.map((pool) => pool.id);
    selectedPools &&
      selectedPools.length > 0 &&
      selectedPools.forEach((pool) => {
        currState?.accessroles.forEach((role) => {
          roles.roles[pool].find((storeRole) => storeRole === role.id) &&
            selectedaccessroles.push(role);
        });
      });

    generateAccessRoles(poolroles, selectedaccessroles);
  };

  const generateFinalObject = (formvalues) => {
    const {
      "custom:uid": uid,
      "custom:phoneNumber": phoneNumber,
      "custom:mobileNumber": mobile_number,
      "custom:accessrole": accessrole,
      "custom:userpoolRole": userpoolRole,
      "custom:Country": country,
      email,
      given_name,
      family_name,
      codeMb,
      cognitoSuperAdmin,
    } = formvalues;
    let finalArray = [];
    let accessRoleFormat =
      accessrole && accessrole.length > 0
        ? accessrole.map((role) => role.id)
        : [];
    let userpoolRolesFormat =
      userpoolRole && userpoolRole.length > 0
        ? userpoolRole.map((role) => role.id)
        : [];
    let object = {
      "custom:uid": uid || " ",
      preferred_username: uid || " ",
      "custom:phoneNumber": phoneNumber || " ",
      "custom:mobileNumber": mobile_number ? `+${codeMb}${mobile_number}` : " ",
      "custom:accessrole": cognitoSuperAdmin
        ? "COGNITO_SUPER_ADMIN"
        : accessRoleFormat.length > 0
        ? accessRoleFormat.join(",")
        : " ",
      "custom:userpoolRole": !cognitoSuperAdmin
        ? userpoolRolesFormat.length > 0
          ? userpoolRolesFormat.join(",")
          : " "
        : " ",
      "custom:Country": country || " ",
      email: email,
      given_name: given_name || " ",
      family_name: family_name || " ",
      "custom:displayname": `${family_name},${given_name}` || " ",
    };
    Object.keys(object).forEach((key) => {
      finalArray.push({
        Name: key,
        Value: object[key],
      });
    });
    return finalArray;
  };

  const generatePhoneNumber = (number) => {
    let code =
      number && number.length > 10 && number.substring(1, number.length - 10);
    let ph_number =
      number &&
      number.length > 10 &&
      number.substring(number.length - 10, number.length);
    return {
      code: code || "",
      ph_number: ph_number || "",
    };
  };

  return (
    <>
      <DocumentTitle
        title={`Doorkeeper | ${
          // !currState?.userID ? "Create Admin" : "Modify Admin"
          !userId ? "Create Admin" : "Modify Admin"
        }`}
      >
        <React.Fragment>
          {/* <h5>{!currState?.userID ? "Create Admin" : "Modify Admin"}</h5> */}
          <h5>{!userId ? "Create Admin" : "Modify Admin"}</h5>

          <Formik
            enableReinitialize={
              currState?.aTouch ||
              currState?.uTouch ||
              currState?.rTouch ||
              currState?.adminTouch
                ? false
                : true
            }
            initialValues={{
              "custom:uid": (userDetails && userDetails["custom:uid"]) || "",
              "custom:phoneNumber":
                (userDetails && userDetails["custom:phoneNumber"]) || "",
              "custom:mobileNumber":
                (userDetails &&
                  generatePhoneNumber(userDetails["custom:mobileNumber"])
                    .ph_number) ||
                "",
              "custom:accessrole": (userDetails && currState.accessroles) || "",
              "custom:userpoolRole":
                (userDetails && currState.userpoolRoles) || "",
              "custom:Country":
                (userDetails && userDetails["custom:Country"]) || "",
              email: (userDetails && userDetails["email"]) || "",
              given_name: (userDetails && userDetails["given_name"]) || "",
              family_name: (userDetails && userDetails["family_name"]) || "",
              codeMb:
                (userDetails &&
                  generatePhoneNumber(userDetails["custom:mobileNumber"])
                    .code) ||
                "",
              cognitoSuperAdmin:
                (userDetails && currState.cognito_super_admin) || false,
            }}
            validationSchema={Yup.object().shape({
              "custom:uid": Yup.string().required("UID is required"),
              email: Yup.string()
                .required("Email is required")
                .email("Invalid email"),
              given_name: Yup.string()
                .required("First Name is required")
                .test(
                  "validateFirstName",
                  "Invalid First Name",
                  (firstName) => {
                    return isEmpty(String(firstName).trim()) ? false : true;
                  }
                ),
              family_name: Yup.string()
                .required("Last Name is required")
                .test("validateLastName", "Invalid Last Name", (lastName) => {
                  return isEmpty(String(lastName).trim()) ? false : true;
                }),
              // codeMb: Yup.string().when("custom:mobileNumber", {
              //   is: (mobile_number) => mobile_number,
              //   then: Yup.string().required("Code required"),
              // }),
              codeMb: Yup.string().when("custom:mobileNumber", {
                is: (mobile_number) => mobile_number,
                then: () => Yup.string().required("Code required"),
              }),
              "custom:mobileNumber": Yup.string()
                .matches(/^[0-9]+$/, "Must be only digits")
                .min(10, "Must be exactly 10 digits")
                .max(10, "Must be exactly 10 digits"),
            })}
            onSubmit={(values) => {
              let finalArray = generateFinalObject(values);
              if (!currState?.userID) {
                adminCreateUserFn(finalArray, values.email);
              } else {
                updateAdminUserFn(currState?.userID, finalArray);
              }
            }}
            onReset={() => {
              clearErrorFn();
              setCurrState({
                ...currState,
                modal: false,
                message: "",
                color: "",
                aTouch: false,
                uTouch: false,
                rTouch: false,
                adminTouch: false,
              });
              if (currState?.userID) {
                clearModifyUserFn();
              } else {
                setCurrState({
                  ...currState,
                  userpoolRoles: [],
                  roles: [],
                  accessroles: [],
                  cognito_super_admin: false,
                });
                clearUserCreatedFn();
              }
            }}
          >
            {({
              handleSubmit,
              values,
              handleBlur,
              touched,
              errors,
              setFieldValue,
              handleReset,
              isSubmitting,
              isValidating,
            }) => (
              <Container
                style={{
                  border: "1.5px solid #ddd",
                  padding: "1% 5%",
                  overflowY: "auto",
                  height: "70vh",
                }}
              >
                {isLoading && <Loading />}
                {error && currState?.modal && (
                  <SubmissionPopup
                    modal={currState.modal}
                    message={currState.message}
                    color={currState.color}
                    toggle={() => {
                      toggle();
                      handleReset();
                    }}
                  />
                )}
                <Form onSubmit={handleSubmit}>
                  <ErrorFocus
                    errors={errors}
                    isSubmitting={isSubmitting}
                    isValidating={isValidating}
                  />
                  <FormGroup row>
                    <Col>
                      <Label>
                        SONY GID:<span className="required">*</span>
                        {"  "}
                      </Label>
                      <Input
                        type="text"
                        name="custom:uid"
                        tag={Field}
                        onBlur={handleBlur}
                        onChange={(event) => {
                          setFieldValue("custom:uid", event.target.value);
                        }}
                        disabled={currState.disabled}
                      />
                      <ErrorMessage
                        errors={errors["custom:uid"]}
                        touched={touched["custom:uid"]}
                      />{" "}
                    </Col>

                    <Col>
                      <Label>
                        Email ID:<span className="required">*</span>
                        {"  "}
                      </Label>
                      <Input
                        type="email"
                        name="email"
                        tag={Field}
                        onBlur={handleBlur}
                        onChange={(event) => {
                          setFieldValue("email", event.target.value);
                        }}
                        disabled={currState.disabled}
                      />
                      <ErrorMessage
                        errors={errors["email"]}
                        touched={touched["email"]}
                      />{" "}
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Col>
                      <Label>
                        First Name:<span className="required">*</span>
                      </Label>
                      <Input
                        type="text"
                        name="given_name"
                        tag={Field}
                        maxLength={30}
                        onBlur={handleBlur}
                        onChange={(event) => {
                          setFieldValue("given_name", event.target.value);
                        }}
                      />
                      <ErrorMessage
                        errors={errors["given_name"]}
                        touched={touched["given_name"]}
                      />{" "}
                    </Col>
                    <Col>
                      <Label>
                        Last Name:<span className="required">*</span>
                        {"  "}
                      </Label>
                      <Input
                        type="text"
                        name="family_name"
                        tag={Field}
                        maxLength={30}
                        onBlur={handleBlur}
                        onChange={(event) => {
                          setFieldValue("family_name", event.target.value);
                        }}
                      />
                      <ErrorMessage
                        errors={errors["family_name"]}
                        touched={touched["family_name"]}
                      />{" "}
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Col sm={4}>
                      <Label>Mobile Number:</Label>
                      <InputGroup>
                        <InputGroupAddon
                          addonType="prepend"
                          style={{ width: "40px" }}
                        >
                          <Input
                            addon
                            tag={Field}
                            name="codeMb"
                            value={values.codeMb}
                            onChange={(e) => {
                              setFieldValue("codeMb", e.target.value);
                            }}
                          />
                        </InputGroupAddon>
                        <Input
                          maxLength={10}
                          type={"text"}
                          name="custom:mobileNumber"
                          tag={Field}
                          onChange={(event) => {
                            setFieldValue(
                              "custom:mobileNumber",
                              event.target.value
                            );
                          }}
                          onBlur={handleBlur}
                          value={values["custom:mobileNumber"]}
                        />{" "}
                      </InputGroup>
                      <ErrorMessage
                        errors={errors["codeMb"]}
                        touched={touched["codeMb"]}
                      />{" "}
                      <ErrorMessage
                        errors={errors["custom:mobileNumber"]}
                        touched={touched["custom:mobileNumber"]}
                      />{" "}
                    </Col>
                    <Col sm={4}>
                      <Label>Phone Number:</Label>
                      <Input
                        maxLength={10}
                        type={"text"}
                        name="custom:phoneNumber"
                        tag={Field}
                        onChange={(event) => {
                          setFieldValue(
                            "custom:phoneNumber",
                            event.target.value
                          );
                        }}
                        onBlur={handleBlur}
                        value={values["custom:phoneNumber"]}
                      />{" "}
                    </Col>
                    <Col sm={4}>
                      <Label>Country:</Label>
                      <Input
                        component={"select"}
                        name="custom:Country"
                        tag={Field}
                        onChange={(event) => {
                          setFieldValue("custom:Country", event.target.value);
                        }}
                      >
                        {optionListCountries(countries)}
                      </Input>
                    </Col>
                  </FormGroup>
                  {superAdmin && (
                    <FormGroup row>
                      <Col md={4}>
                        <Label for="cognitoSuperAdmin" id="cognitoSuperAdmin">
                          Super Admin:
                        </Label>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <Input
                          style={{ marginBottom: "-1%" }}
                          type={"checkbox"}
                          name="cognitoSuperAdmin"
                          checked={currState.cognito_super_admin}
                          onChange={(e) => {
                            setCurrState({
                              ...currState,
                              adminTouch: true,
                              cognito_super_admin: e.target.checked,
                            });
                            setFieldValue(
                              "cognitoSuperAdmin",
                              e.target.checked
                            );
                          }}
                        />
                      </Col>
                    </FormGroup>
                  )}

                  <FormGroup row>
                    <Col md={12}>
                      <Label className="floatLeft">User pool(s):</Label>
                      <MultiSelect
                        height={1}
                        style={{ height: "300px" }}
                        name={"custom:userpoolRole"}
                        items={_.orderBy(staticPoolRoles, "disabled", "asc")}
                        selectedItems={_.orderBy(
                          currState.userpoolRoles,
                          "disabled",
                          "asc"
                        )}
                        onChange={(userpoolRoles) => {
                          // let newState = {
                          //   userpoolRoles: userpoolRoles,
                          //   aTouch: true,
                          // };
                          // setCurrState((prevState) => ({
                          //   ...prevState,
                          //   ...newState,
                          // }));
                          // setCurrState({
                          //   ...currState,
                          //   userpoolRoles: userpoolRoles,
                          //   uTouch: true,
                          // });
                          filterSelectedAccessRoles(userpoolRoles);
                          //generateAccessRoles(userpoolRoles);
                          setFieldValue("custom:userpoolRole", userpoolRoles);
                        }}
                      />
                    </Col>

                    {currState?.userpoolRoles &&
                      currState?.userpoolRoles.length > 0 && (
                        <Col md={12}>
                          <Label className="floatLeft">Access Role(s):</Label>
                          <MultiSelect
                            height={1}
                            style={{ height: "300px" }}
                            name={"custom:accessrole"}
                            items={_.orderBy(
                              currState.rolesList,
                              "disabled",
                              "asc"
                            )}
                            selectedItems={_.orderBy(
                              currState.accessroles,
                              "disabled",
                              "asc"
                            )}
                            onChange={(accessroles) => {
                              setCurrState({
                                ...currState,
                                accessroles: accessroles,
                                aTouch: true,
                              });
                              setFieldValue("custom:accessrole", accessroles);
                            }}
                          />
                        </Col>
                      )}
                  </FormGroup>
                  <FormGroup row>
                    <Col className="text-center text-md-right">
                      <Button
                        type="reset"
                        tag={Link}
                        to={currState?.userID ? "/modifyadmin" : "/"}
                      >
                        Cancel
                      </Button>
                      &nbsp;
                      <Button type="submit">Submit</Button>
                    </Col>
                  </FormGroup>
                </Form>
              </Container>
            )}
          </Formik>
        </React.Fragment>
      </DocumentTitle>
    </>
  );
};

export default AdminForm;
